import * as React from 'react';
import List from '../components/List';
import { MENUS_REQUEST_ACTONS_MAPPING } from '../utils';

const MENU_KEY = MENUS_REQUEST_ACTONS_MAPPING['lsSettled'];

export default class Settled extends React.Component<any, any> {
  public render() {
    return <List menuKey={MENU_KEY} {...this.props} />;
  }
}
